import { filterFormEntries } from '@contracts/order/FormEntriesFilter';
import type { Location } from '@remix-run/router';
import { PrefilledForm } from '@src/common/utils/form/FormPrefilling';
import type { Tractor } from '@src/tractor/domain/Tractor';
import type { TrailerListing } from '@src/trailer/domain/TrailerList';

export const OrderUnsavedChanges = {
  restore: ({
    location,
    currentFields,
    trailers,
    tractors,
  }: {
    location: Location;
    currentFields: string[];
    trailers: TrailerListing[];
    tractors: Tractor[];
  }) => {
    const previousValues = location.state?.preservedValues;
    if (!previousValues) return;

    // Filter preserved values to only include entries that are valid for the current permit fields.
    // This prevents stale data from being restored when permit types change.
    const filteredPreviousValues = filterFormEntries(
      previousValues,
      currentFields,
    );

    return PrefilledForm({
      currentEntries: filteredPreviousValues,
      currentFields,
      trailers,
      tractors,
    });
  },
};
